export const filterScopeBySitesAndLocations = (
  scope = [],
  sites = [],
  locations = []
) => {
  return scope
    .filter((site) => {
      return sites.includes(site.value);
    })
    .map((site) => {
      return {
        ...site,
        locations: site.locations.filter((location) => {
          return locations.includes(location.value);
        }),
      };
    });
};
